<nz-collapse nzGhost>
  <nz-collapse-panel
    nzCollapsible="icon"
    [nzHeader]="'general.selection' | translate"
    [nzActive]="true"
  >
    @for (
      userQualification of bulkEditSelection$ | async;
      track userQualification
    ) {
      <li nz-list-item class="selection-list">
        <span>{{ userQualification.userId | userName | async }}</span>
        <span>{{
          userQualification.qualificationId | qualificationV2Name | async
        }}</span>
      </li>
    }
  </nz-collapse-panel>
</nz-collapse>
